var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHelpTextContent)?_c('div',{staticClass:"help-text__wrapper"},[_c('div',{staticClass:"container-fluid help-text"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.help_text)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }